import request from './base'

export const onPlayVideo = (params) => {
    return request.post("/merchant/v1/media/play", params)
}

export const onStopVideo = (params) => {
    return request.post("/merchant/v1/media/destroy",params)
}


// WEBPACK FOOTER //
// ./src/api/media.js